import { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Box, Button, Paper, Stack, Typography, Divider } from "@mui/material";
import { api } from "../../../utils/api";

export default function VendorDetailsPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [data, setData] = useState(null);

    useEffect(() => {
        api.get(`/vendors/${id}`).then((res) => {
            setData(res.data?.data || null);
        });
    }, [id]);

    const contractFile = data?.contract?.contractFile || null;

    const fileUrl = useMemo(() => {
        const url = contractFile?.url || "";
        if (!url) return "";
        if (url.startsWith("http")) return url;

        const origin = new URL(api.defaults.baseURL).origin; // ✅ https://api.hr-ebnhaian.cloud
        return `${origin}${url}`; // ✅ https://api.hr-ebnhaian.cloud/uploads/vendors/...
    }, [contractFile]);


    const originalName = contractFile?.originalName || "";
    const isPdf =
        !!fileUrl &&
        (fileUrl.toLowerCase().endsWith(".pdf") ||
            originalName.toLowerCase().endsWith(".pdf"));

    if (!data) return <Box p={2}>Loading...</Box>;

    return (
        <Box p={2}>
            <Stack direction="row" justifyContent="space-between" mb={2}>
                <Button variant="outlined" onClick={() => navigate(-1)}>
                    Back
                </Button>
                <Typography variant="h6">Vendor Details</Typography>
            </Stack>

            <Paper sx={{ p: 2 }}>
                <Typography variant="h5">{data.name}</Typography>
                <Typography sx={{ opacity: 0.7 }}>
                    {data.center?.name
                        ? `${data.center.name} (${data.center.code})`
                        : "-"}
                </Typography>

                <Divider sx={{ my: 2 }} />

                <Stack spacing={1}>
                    <Typography>Type: {data.type || "-"}</Typography>
                    <Typography>Phone: {data.phone || "-"}</Typography>
                    <Typography>Email: {data.email || "-"}</Typography>

                    <Divider sx={{ my: 1 }} />

                    <Typography>
                        Contract Type: {data.contract?.pricingType || "-"}
                    </Typography>
                    <Typography>
                        Amount: {data.contract?.amount ?? "-"}{" "}
                        {data.contract?.currency || ""}
                    </Typography>
                    <Typography>Status: {data.contract?.status || "-"}</Typography>
                    <Typography>
                        Start Date:{" "}
                        {data.contract?.startDate
                            ? data.contract.startDate.slice(0, 10)
                            : "-"}
                    </Typography>
                    <Typography>
                        End Date:{" "}
                        {data.contract?.endDate
                            ? data.contract.endDate.slice(0, 10)
                            : "-"}
                    </Typography>

                    <Divider sx={{ my: 1 }} />

                    <Typography variant="subtitle1" sx={{ mt: 1 }}>
                        Contract File:
                    </Typography>

                    {!fileUrl ? (
                        <Typography sx={{ opacity: 0.7 }}>
                            No contract file uploaded
                        </Typography>
                    ) : (
                        <Stack direction="row" spacing={2} alignItems="center">
                            <Typography sx={{ opacity: 0.8 }}>
                                {originalName ||
                                    contractFile?.fileName ||
                                    "Contract File"}
                            </Typography>

                            <Button
                                variant="contained"
                                onClick={() => window.open(fileUrl, "_blank")}
                            >
                                Open
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={() => navigator.clipboard.writeText(fileUrl)}
                            >
                                Copy Link
                            </Button>
                        </Stack>
                    )}

                    {fileUrl && isPdf && (
                        <Box sx={{ mt: 2, height: 600 }}>
                            <iframe
                                title="Contract Preview"
                                src={fileUrl}
                                style={{ width: "100%", height: "100%", border: 0 }}
                            />
                        </Box>
                    )}

                    {fileUrl && !isPdf && (
                        <Box sx={{ mt: 2 }}>
                            <img
                                src={fileUrl}
                                alt="Contract"
                                style={{ maxWidth: "100%", borderRadius: 8 }}
                            />
                        </Box>
                    )}
                </Stack>
            </Paper>
        </Box>
    );
}
